/**
 * D6DamageLTConditionType - Condition qui vérifie si les Dégâts sont inférieurs à une valeur
 * Identique à Java DamageLTCondition
 */

import {ConditionType} from '../../types/ConditionType';
import {GameState} from '../../../models/GameState';
import GameStateHelper from '../../../helpers/GameStateHelper';

export class D6DamageLTConditionType implements ConditionType {
  typeName = 'D6_COND_DAMAGE_LT';
  messageKey = 'laventurier.condition.d6.damage-lt.name';
  descriptionKey = 'laventurier.condition.d6.damage-lt.desc';
  errorKey = 'laventurier.condition.d6.damage-lt.error';
  hasValue = true;
  hasAttribute = false;

  evaluate(gameState: GameState, condition: any): boolean {
    const threshold = parseInt(condition.value || condition.threshold || '0', 10);
    if (isNaN(threshold)) {
      console.log('[D6DamageLTConditionType] FALSE: invalid threshold value');
      return false;
    }

    const damageField = GameStateHelper.getAdventureExtraField(gameState, 'D6_DAMAGE');
    if (!damageField) {
      console.log('[D6DamageLTConditionType] FALSE: D6_DAMAGE field not found');
      return false;
    }

    const currentDamage = parseInt(String(damageField.currentValue || damageField.initValue || '0'), 10);
    const result = currentDamage < threshold;
    console.log(`[D6DamageLTConditionType] ${result ? 'TRUE' : 'FALSE'}: currentDamage=${currentDamage}, threshold=${threshold}`);
    return result;
  }
}
